import { clsx } from 'clsx';
import { Box } from '@material-ui/core';

import { ItemAvatar } from 'shared/components';

import makeClasses from './ItemItemWithAvatar.style';

import type { BoxProps } from '@material-ui/core/Box';

export function ItemCardWithAvatar(props: ItemCardWithAvatarProps) {
  const { imageUrl, title, description, classes = {}, cardProps = {} } = props;

  const _classes = makeClasses();

  return (
    <Box className={clsx(_classes.card, classes.card)} {...cardProps}>
      {!!imageUrl && (
        <ItemAvatar
          alt={title}
          src={imageUrl}
          className={clsx(_classes.image, classes.image)}
        />
      )}
      <div className={classes.infoContainer}>
        {!!title && (
          <h3 className={clsx(_classes.title, classes.title)}>{title}</h3>
        )}
        {!!description && (
          <p className={clsx(_classes.description, classes.description)}>
            {description}
          </p>
        )}
      </div>
    </Box>
  );
}

export interface ItemCardWithAvatarProps {
  title?: string;
  imageUrl?: string;
  description?: string;
  classes?: {
    card?: string;
    infoContainer?: string;
    image?: string;
    title?: string;
    description?: string;
  };
  cardProps?: Partial<BoxProps>;
}
